import React from 'react';
import { Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { BrowserRouter, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import awsconfig from './aws-exports';
import Dashboard from './components/Dashboard';
import RsvpManager from './components/RsvpManager';
import SeatingChart from './components/SeatingChart';
import EventTimeline from './components/EventTimeline';
import './App.css';

// Configure Amplify
Amplify.configure(awsconfig);

function AppLayout({ signOut, user }) {
  return (
    <div className="app">
      <header className="app-header">
        <h1>Erika and Andrew's Wedding Admin</h1>
        <nav className="app-nav">
          <NavLink to="/" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Dashboard</NavLink>
          <NavLink to="/rsvp" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>RSVP List</NavLink>
          <NavLink to="/seating-chart" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Seating Chart</NavLink>
          <NavLink to="/event-timeline" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>Event Timeline</NavLink>
        </nav>
        <div className="user-info">
        <span className="username">{user.attributes?.name || user.username}</span>
          <button onClick={signOut} className="signout-button">Sign Out</button>
        </div>
      </header>
      
      <main>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/rsvp" element={<RsvpManager />} />
          <Route path="/seating-chart" element={<SeatingChart />} />
          <Route path="/event-timeline" element={<EventTimeline />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
    </div>
  );
}

// Configure authentication options to hide signup
const authenticationOptions = {
  // Hide the Create Account option
  hideSignUp: true,
  
  // Customize the login form
  loginMechanisms: ['email'],
  
  // Customize the login labels
  formFields: {
    signIn: {
      username: {
        label: 'Email',
        placeholder: 'Enter your email',
      },
      password: {
        label: 'Password',
        placeholder: 'Enter your password',
      }
    }
  }
};

// Wrap the app layout with authentication and pass options
const AuthenticatedAppLayout = withAuthenticator(AppLayout, authenticationOptions);

function App() {
  return (
    <BrowserRouter>
      <AuthenticatedAppLayout />
    </BrowserRouter>
  );
}

export default App;